import React from "react";
import { CheckCircle2, Sparkles } from "lucide-react";

const Step4Done = ({ paymentMode, family }) => (
  <div className="text-center py-6" data-testid="inscription-done">
    <CheckCircle2 size={64} className="mx-auto text-emerald-500" />
    <h3 className="font-serif-display text-2xl sm:text-3xl text-stone-800 mt-5">Inscription enregistrée&nbsp;!</h3>
    {paymentMode === "cheque" && (
      <p className="text-stone-600 mt-3 max-w-md mx-auto">
        Pensez à <strong>déposer votre chèque</strong> à l&apos;école (ou par courrier), à l&apos;ordre de <strong>L&apos;Élan Danse</strong>, en précisant le nom de l&apos;élève au dos.
      </p>
    )}
    {paymentMode === "especes" && (
      <p className="text-stone-600 mt-3 max-w-md mx-auto">
        Le règlement en <strong>espèces</strong> se fera lors de votre passage au studio à la rentrée.
      </p>
    )}
    {(paymentMode === "card" || paymentMode === "monthly") && (
      <p className="text-stone-600 mt-3 max-w-md mx-auto">
        Si le paiement a été confirmé, vous le verrez dans votre espace famille. Sinon, vous pouvez le finaliser depuis votre compte.
      </p>
    )}
    <div className="mt-4 bg-blush-light rounded-xl p-4 max-w-md mx-auto text-sm text-stone-700">
      <Sparkles size={14} className="inline text-deep-rose mr-1" /> Un compte famille a été créé avec l&apos;email <strong>{family.email}</strong>. Connectez-vous pour suivre vos inscriptions et paiements.
    </div>
    <div className="flex flex-col sm:flex-row gap-3 justify-center mt-6">
      <a href="/espace-famille/login" className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-coral text-white text-sm tracking-widest uppercase">Accéder à mon espace</a>
      <a href="/" className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-stone-100 text-stone-700 text-sm tracking-widest uppercase">Retour au site</a>
    </div>
  </div>
);

export default Step4Done;
